import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["spacing", "children"];
import React from 'react';
import Stack from 'components/Stack';
function FormStack(_ref) {
  var _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 'm' : _ref$spacing,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Stack, _extends({}, otherProps, {
    spacing: spacing
  }), children);
}
export default FormStack;